import { FC, PropsWithChildren } from 'react';
import { IconButton } from '@tuic/web-compositions/core/IconButton';
import { useClientTranslation } from '@lib/i18n/client';
import { useViewStack } from '@modules/get-slash-internet-card/components/dialog-views/view-stack';

type Props = PropsWithChildren<{
  title?: string;
}>;

export const ViewStackViewWithNavigation: FC<Props> = ({ title, children }) => {
  const { t } = useClientTranslation();

  const { popable, pop } = useViewStack();

  return (
    <div className="space-y-8 text-marine-high-emphasis">
      <div className="relative min-h-[48px]">
        {popable && (
          <div>
            <IconButton
              iconName="arrow-left"
              title={t('Zurück')}
              variant="secondary"
              size="md"
              onClick={pop}
            />
          </div>
        )}
        {title && (
          <div
            className="
            absolute left-0 right-0 top-1/2 -translate-y-1/2 mx-[2em] px-2
            headline-lg text-center
          "
          >
            {title}
          </div>
        )}
      </div>

      {children}
    </div>
  );
};
